var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"jira-update-button",attrs:{"width":"100px","type":"image","src":_vm.displayImg,"alt":_vm.$lang('synchornizacja z Jira')},on:{"click":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }